import React, { createContext, useContext, useEffect, useState } from 'react';

export const THEME_KEY = 'quantros.theme';
const normalize = value => ['light', 'dark', 'auto'].includes(value) ? value : 'auto';
export function readTheme() {
  try { return normalize(localStorage.getItem(THEME_KEY)); } catch { return 'auto'; }
}
export function applyTheme(preference) {
  const dark = preference === 'dark' || (preference === 'auto' && window.matchMedia?.('(prefers-color-scheme: dark)').matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
}
const ThemeContext = createContext(null);
export function ThemeProvider({ children }) {
  const [preference, setPreference] = useState(readTheme);
  useEffect(() => {
    applyTheme(preference);
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    const update = () => applyTheme(preference);
    media?.addEventListener('change', update);
    return () => media?.removeEventListener('change', update);
  }, [preference]);
  useEffect(() => {
    const sync = event => {
      if (event.key === THEME_KEY || event.key === null) setPreference(readTheme());
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  const setTheme = value => {
    const next = normalize(value);
    try { localStorage.setItem(THEME_KEY, next); } catch { /* Still usable without storage. */ }
    applyTheme(next);
    setPreference(next);
  };
  return <ThemeContext.Provider value={{ preference, setTheme }}>{children}</ThemeContext.Provider>;
}
export const useTheme = () => useContext(ThemeContext);
